import React from "react";
import { useMountEffect } from "@reonomy/reactive-hooks";
import { Card, Table } from "antd";
import { useIntl, defineMessages } from "react-intl";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import CloudChannelsServices from "../../services/cloudChannels";
import { selectors as CLOUD_CHANNELS_SELECTORS } from "../../ducks/cloudChannels";

import { errorNotification } from "../../lib/utils/notification";
import parseCloudId from "../../lib/utils/parseCloudId";

const translations = defineMessages({
  channelName: {
    id: "AllChannelsList.channelName",
    defaultMessage: "Share name",
  },
  id: {
    id: "AllChannelsList.id",
    defaultMessage: "ID",
  },
  owner: {
    id: "AllChannelsList.owner",
    defaultMessage: "Owner",
  },
});

const AllChannelsList = ({ allChannelsList }) => {
  const { formatMessage } = useIntl();

  async function fetchChannels() {
    CloudChannelsServices.getAllChannels({ errorNotification: errorNotification(formatMessage) });
  }

  useMountEffect(() => {
    fetchChannels();
  });

  const columns = [
    {
      key: "channelName",
      dataIndex: "channelName",
      title: formatMessage(translations.channelName),
      sorter: (currentValue, nextValue) => currentValue.channelName.localeCompare(nextValue.channelName),
      render: (text, { id, channelName }) => (
        <Link key={id} to={`/channel/all/${id}`}>
          <span>{channelName}</span>
        </Link>
      ),
    },
    {
      key: "cloudId",
      dataIndex: "cloudId",
      title: formatMessage(translations.id),
      sorter: (currentValue, nextValue) => currentValue.cloudId - nextValue.cloudId,
      render: (cloudId) => {
        return parseCloudId(cloudId);
      },
    },
    {
      key: "id",
      dataIndex: "userId",
      title: formatMessage(translations.owner),
      sorter: (currentValue, nextValue) => currentValue.userId.localeCompare(nextValue.userId),
    },
  ];

  return (
    <Card>
      <Table columns={columns} dataSource={allChannelsList} rowKey={(record) => record.id} />
    </Card>
  );
};

const mapStateToProps = (state) => ({
  allChannelsList: CLOUD_CHANNELS_SELECTORS.getAllChannels(state),
});

AllChannelsList.propTypes = {
  allChannelsList: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.shape({
        cloudId: PropTypes.number.isRequired,
        channelName: PropTypes.string.isRequired,
        id: PropTypes.number.isRequired,
        isEncrypted: PropTypes.bool.isRequired,
        isPublic: PropTypes.bool.isRequired,
        userId: PropTypes.string.isRequired,
      })
    ),
    PropTypes.array,
  ]).isRequired,
};

export default connect(mapStateToProps, null)(AllChannelsList);
